import { useEffect, useState } from "react";
//@ts-ignore
import { MUIEditorState } from "react-mui-draft-wysiwyg";
import { useParams } from "react-router-dom";
import { useAppContext } from "../../../../context/AuthContext";
import { TicketController, TicketControllerType } from "../../../../controller/ticket/TicketCotroller";
import { handleErrorMessage } from "../../../../utils/Utils";

interface TicketEditServiceType {
  ticket: any;
  editorState: any;
  setEditorState: any;
  authData: any;
  sendTicketResponse: any;
}

export default function TicketEditService(): TicketEditServiceType {
  const [editorState, setEditorState] = useState(MUIEditorState.createEmpty());
  const [ticket, setTicket] = useState<any>([]);
  const { authData, showMessage } = useAppContext();
  const { id }: any = useParams();

  const { axiosGetTicketById, axiosTicketResponse }: TicketControllerType = TicketController();

  useEffect(() => {
    getTicketByID(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTicketByID = (id: number) => {
    axiosGetTicketById(id)
      .then((result: any) => {
        setTicket(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const sendTicketResponse = (id: number, content: any) => {
    axiosTicketResponse(id, content)
      .then((response: any) => {
        setEditorState(MUIEditorState.createEmpty());
        getTicketByID(id);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return { ticket, editorState, setEditorState, authData, sendTicketResponse };
}

export type { TicketEditServiceType };
